import * as Constants from "../consts/Constants";

class Redirection {
  constructor() {
    this.indexMap = new Map();
    this.indexMap.set(Constants.ROLE_ADMIN_ID, Constants.ROUTE_DASHBOARD);
    this.indexMap.set(Constants.ROLE_PRESS_ADMIN_ID, Constants.ROUTE_NEWS);
    this.indexMap.set(
      Constants.ROLE_POLICE_ADMIN_ID,
      Constants.ROUTE_EMERGENCY
    );
    this.indexMap.set(Constants.ROLE_HEALTH_ADMIN_ID, Constants.ROUTE_COVID);
    this.indexMap.set(Constants.ROLE_REPORTS_ADMIN_ID, Constants.ROUTE_REPORTS);
    this.indexMap.set(Constants.ROLE_EVENTS_ADMIN_ID, Constants.ROUTE_EVENTS);
  }

  getIndexByRoles(roles) {
    for (let i = 0; i < roles.length; i++) {
      if (this.indexMap.get(roles[i]) !== undefined) {
        return this.indexMap.get(roles[i]);
      }
    }
  }
}

export default new Redirection();
